import { useQuery } from '@apollo/client';

import { QUESTION_IDS } from 'bundles/onboarding-common/constants/questionScheme';
import LearnerObjectAttributesInterestedCareersQuery from 'bundles/onboarding-common/queries/LearnerObjectAttributesInterestedCareers.graphql';
import type {
  LearnerObjectAttributesInterestedCareersQuery as LearnerObjectAttributesInterestedCareersQueryType,
  LearnerObjectAttributesInterestedCareersQueryVariables,
} from 'bundles/onboarding-common/queries/__generated__/LearnerObjectAttributesInterestedCareers';
import { formatInterestedCareersFromLearnerObject } from 'bundles/onboarding-common/utils/savedQuestionDataUtils';

const useLearnerObjectInterestedCareersData = ({ skip }: { skip?: boolean }) => {
  const { data, loading, error } = useQuery<
    LearnerObjectAttributesInterestedCareersQueryType,
    LearnerObjectAttributesInterestedCareersQueryVariables
  >(LearnerObjectAttributesInterestedCareersQuery, {
    context: { clientName: 'gatewayGql' },
    errorPolicy: 'all',
    fetchPolicy: 'network-only',
    skip,
  });

  return {
    value: formatInterestedCareersFromLearnerObject(data),
    loading,
    error,
    __typename: QUESTION_IDS.roleSelect,
  };
};

export default useLearnerObjectInterestedCareersData;
